import React, { useContext, useEffect, useState } from "react";
import { FieldArray } from "formik";
import {
  Card,
  CardBody,
  CardHeader,
  Button,
  Row,
  Col,
  Label,
  Input,
} from "reactstrap";
import { Link } from "react-router-dom";
import {
  handleGrantsAndChargesResourceValueAndUsageFields,
  handleGrantsAndChargesRecurringFrequencyAndUsageOptions,
} from "./constants/GrantsAndRecurringFunctions";
import {
  CycleAlignmentOption,
  pricingModelOptions,
} from "./constants/initialValues";
import UsageRatePlanRowRecurring from "./UsageRatePlanRowRecurring";
import { isEmptyOrInvalidFieldRecurring } from "./constants/checkEmptyFields";
import BalanceImpactTableRecurring from "./BalanceImpactTableRecurring";
import AttributeBasedDetailsTableRecurring from "./AttributeBasedDetailsTableRecurring"; // Add this import
import { CreateOfferContext } from "./context";
import { LabelText } from "../../Utils/Input";
import { handleRadioUsageTypeChange } from "../../Customers/constants/HandleChangeFunctions";

export default function UsageRatePlanRecurring({ pushRef }) {
  const {
    values,
    errors,
    isEdit,
    isSubscribed,
    touched,
    setFieldTouched,
    setFieldValue,
    setTouched,
    isEmptyOrInvalidField,
    handleChange,
    resourceNameOptions,
    uomOptions,
    isSubmitting,
    sectionRefs,
  } = useContext(CreateOfferContext);
  const [showPricingModel, setShowPricingModel] = useState(
    Array(values.recurringUsageRatePlan.length).fill(false)
  );
  const [balanceDropdown, setBalanceDropdown] = useState(false);
  const [attributeDropdown, setAttributeDropdown] = useState(false); // Add this state
  const [usageType, setUsageType] = useState("1");

  const toggleBalanceDropdown = () => {
    setBalanceDropdown(!balanceDropdown);
  };

  // Add this function
  const toggleAttributeDropdown = () => {
    setAttributeDropdown(!attributeDropdown);
  };

  const togglePricingModel = (index) => {
    setShowPricingModel((prevState) => {
      const newState = [...prevState];
      newState[index] = !newState[index];
      return newState;
    });
  };

  useEffect(() => {
    if (isEdit) {
      const updatedShowPricingModel = values.usageRatePlan.map(
        (urp) =>
          urp.pricingModel?.value === "volume" &&
          urp.pricingModelNew?.length > 0
      );
      setShowPricingModel(updatedShowPricingModel);
    }
  }, [values.usageRatePlan, isEdit]);

  return (
    <FieldArray name="recurringUsageRatePlan">
      {({ push, remove }) => {
        pushRef.current = push;
        return (
          <div className="live-preview">
            {values?.usageRatePlan?.length > 0 &&
            values?.recurringUsageRatePlan?.length === 0 ? (
              <div
                className="d-flex flex-column justify-content-center align-items-center"
                style={{ marginTop: "120px" }}
              >
                {isSubscribed ? (
                  <div className="text-center mb-2">
                    There are no Usage available for this offer.
                  </div>
                ) : (
                  <div className="text-center mb-2">
                    There are no Usage available for this offer, Add a Usage to
                    proceed.
                  </div>
                )}
              </div>
            ) : (
              values?.recurringUsageRatePlan.map((val, index) => {
                const keyIndex =
                  values?.recurringUsageRatePlan?.length - (index + 1);
                const usageRef =
                  sectionRefs.current[`recurringUsageRatePlan${keyIndex + 1}`];
                return (
                  <div
                    key={keyIndex}
                    className="border border-opacity-50 rounded-0 mb-3"
                    ref={usageRef}
                  >
                    <Row className="mb-0 px-3 pt-3">
                      <Col
                        xs={12}
                        className="d-flex justify-content-between align-items-center mb-3"
                      >
                        <h3 className="card-title mb-0">
                          Usage Rate Plan {keyIndex > 0 ? keyIndex + 1 : ""}
                        </h3>
                        <div className="d-flex ms-auto me-5 mt-1">
                          <div className="me-4">
                            <Input
                              type="radio"
                              name={`recurringUsageRatePlan[${keyIndex}].type`}
                              className="me-2"
                              checked={
                                values?.recurringUsageRatePlan[keyIndex]
                                  .type === "1"
                              }
                              onChange={handleRadioUsageTypeChange(
                                "1",
                                setFieldValue,
                                `recurringUsageRatePlan[${keyIndex}].type`
                              )}
                              disabled={isSubscribed}
                            />
                            {/* <OneTimeIcon /> */}
                            <LabelText
                              displayText={"One Time"}
                              classLabelName={"ms-2"}
                            />
                          </div>
                          <div className="me-2">
                            <Input
                              type="radio"
                              name={`recurringUsageRatePlan[${keyIndex}].type`}
                              className="mx-2"
                              checked={
                                values?.recurringUsageRatePlan[keyIndex]
                                  .type === "2"
                              }
                              onChange={handleRadioUsageTypeChange(
                                "2",
                                setFieldValue,
                                `recurringUsageRatePlan[${keyIndex}].type`
                              )}
                              disabled={isSubscribed}
                            />
                            {/* <RecurringIcon /> */}
                            <LabelText
                              displayText={"Recurring"}
                              classLabelName={"ms-2"}
                            />
                          </div>
                        </div>
                        {!isSubscribed && (
                          <Link
                            to="#"
                            className="link-danger"
                            onClick={() => remove(keyIndex)}
                          >
                            <i
                              data-testid="delete"
                              className="ri-delete-bin-5-line"
                            ></i>
                          </Link>
                        )}
                      </Col>
                    </Row>
                    <UsageRatePlanRowRecurring
                      index={keyIndex}
                      val={values?.recurringUsageRatePlan[keyIndex]}
                      isEdit={isEdit}
                      values={values}
                      errors={errors}
                      touched={touched}
                      handleChange={handleChange}
                      handleGrantsAndChargesResourceValueAndUsageFields={
                        handleGrantsAndChargesResourceValueAndUsageFields
                      }
                      handleGrantsAndChargesRecurringFrequencyAndUsageOptions={
                        handleGrantsAndChargesRecurringFrequencyAndUsageOptions
                      }
                      resourceNameOptions={resourceNameOptions}
                      uomOptions={uomOptions}
                      pricingModelOptions={pricingModelOptions}
                      togglePricingModel={togglePricingModel}
                      remove={remove}
                      setFieldValue={setFieldValue}
                      setTouched={setTouched}
                      setFieldTouched={setFieldTouched}
                      isSubscribed={isSubscribed}
                      toggleBalanceDropdown={toggleBalanceDropdown}
                      toggleAttributeDropdown={toggleAttributeDropdown} // Pass this prop
                    />
                  </div>
                );
              })
            )}
          </div>
        );
      }}
    </FieldArray>
  );
}
